import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type ModelAssignmentClearFailedAction = {
	type: 'MODEL_ASSIGNMENT_CLEAR_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): ModelAssignmentClearFailedAction => ({
	type: 'MODEL_ASSIGNMENT_CLEAR_FAILED',
	payload,
});
